(function($, App, Utils, Components){
  'use strict';

  var logger = new Logger("BindEnable");

  Components.create('BindEnable', {

    Selectors: {
      handler: $('[data-bind-enable]'),
    },

    bindEvents: () => {
      if(Components.BindEnable.resetOn)
      {
        Components.on(Components.BindEnable.resetOn, () => {
          let handle = Components.BindEnable.handle;
          handle.is('textarea') ? handle.val('') : handle.prop('checked', false);
          Components.BindEnable.boundElement.addClass('disabled').prop('disabled', true);
        });
      }
    },

    toggle: () => {
      let handle = Components.BindEnable.handle;
      let disabled = handle.is('textarea') ? !$.trim(handle.val()) : !handle.is(':checked');
      Components.BindEnable.boundElement.toggleClass('disabled', disabled).prop('disabled', disabled);
    },

    toggleStatus: () => {
      Components.BindEnable.handle.on('change input', () => {
        Components.BindEnable.toggle();
      });
    },

    init: (handler) => {
      handler = handler || $(Components.BindEnable.Selectors.handler);
      if (handler.length > 0) {
        Components.BindEnable.handle = handler;

        const data = Utils.jsonDA(Components.BindEnable.handle, 'bind');
        Components.BindEnable.boundElement = $(data.enable);
        Components.BindEnable.resetOn = data.reset;
        Components.BindEnable.toggleStatus();
        Components.BindEnable.toggle();
        Components.BindEnable.bindEvents();
      }
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);